import { useEffect, useState } from "react";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "problem", label: "Problem" },
  { id: "loop", label: "Loop" },
  { id: "product", label: "Product" },
  { id: "org-iq", label: "Org IQ" },
  { id: "levels", label: "Levels" },
  { id: "integrations", label: "Integrations" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "border-black bg-white/90 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-5 py-4 md:px-10">
        <button
          data-testid="nav-wordmark"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-xl font-extrabold tracking-tighter"
        >
          Qwiri.ai
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-[11px] font-bold uppercase tracking-[0.2em] text-black/60 transition-colors duration-200 hover:text-black"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-book-demo-btn"
          onClick={() => scrollToId("demo")}
          className="border-2 border-black bg-black px-5 py-2.5 text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors duration-150 hover:bg-white hover:text-black"
        >
          Book a demo
        </button>
      </div>
    </header>
  );
};
